import React from 'react';

import {NewsWidgetProps} from "../models/news-widget.props";
import {NewsWidgetController} from "../news-widget.controller";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import styles from "../styles/news-widget.module.scss";
import classNames from "classnames";
import {List} from "../../../core/components/misc/list/list";
import {NewsWidgetItem} from "./news-widget.item";
import {SeeAllFooterWidget} from "../../../core/components/see-all-footer/see-all-footer";
import {Loader} from "../../../core/components/loading/loader";
import {COMPONENT_STATES, FETCHING_STATES} from "../../../core/consts";
import {NEWS} from "../news-widget.consts";
import {WidgetWrapper} from "../../../core/components/misc/widget-wrapper/widget-wrapper";
import {NewsWidgetEmptyState} from "./news-widget.empty-state";
import {NAVIGATION_TABS} from "../../../modules/navigation-tabs-module/navigation-tabs-module.consts";

export const NewsWidget = ({controller, className, onSeeAllClick}: NewsWidgetProps) => {
  const {state, device, terms} = controller;
  const {isRtl, isMediumView, isLargeView} = device;
  const {news, shouldRenderSeeAll, seeAllLink, magazineId, title, isPreview, isGameContext, isAthleteContext, shouldRenderMicroData, microDataName, isBettingPage} = state;

  const newPreviewListProps = {
    items: news,
    ListItem: NewsWidgetItem,
    listItemProps: {
      controller,
    },
  };

  if(shouldRenderMicroData) {
    newPreviewListProps.itemScope = "";
    newPreviewListProps.itemType = "https://schema.org/ItemList";
    newPreviewListProps.microDataName = microDataName;
  }

  const seeAllProps = {
    isRtl,
    controller,
    linkModel: seeAllLink,
    routeProps: {tabIndex: NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.news},
    onSeeAllClick,
    buttonLabel: terms.SEE_ALL_ARTICLES_ALL_SCORE,
    onClick: () => {
      isGameContext && onSeeAllClick && onSeeAllClick(NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.news);
      controller.action(NEWS.ACTION_TYPES.onSeeAllClick, {
        countryId: state.appState.locale.userCountryId,
        langId: state.appState.locale.language.id,
        sportTypeId: state.appState.context.sportType.id,
        magazineId: magazineId
      })
      return true;
    },
  };

  const isSmallView = !isLargeView && !isMediumView

  const loaderProps = {
    className: classNames(styles.placeholder, {[styles.small_view_placeholder]: isSmallView}, className),
    when: state.fetchingState === FETCHING_STATES.fetching || state.componentState === COMPONENT_STATES.loading
  }

  const wrapperProps = {
    title: isBettingPage ? '' : title,
    className: classNames(styles.container, className, {
      [styles.preview]: isPreview,
      [styles.small_view]: !isLargeView && !isMediumView,
      [styles.athlete_view]: isAthleteContext
    }),
    controller,
    shouldRenderWrapper: isPreview === true
  }

  return (
    <Loader {...loaderProps}>
      <WidgetWrapper {...wrapperProps}>
        <List className={classNames(styles.list_container)} {...newPreviewListProps} />
        {
          shouldRenderSeeAll ? <SeeAllFooterWidget {...seeAllProps}/> : null
        }
      </WidgetWrapper>
      <NewsWidgetEmptyState controller={controller}/>
    </Loader>
  )
};

const settings: ComposeSettings = {
  component: NewsWidget,
  propsType: NewsWidgetProps,
  controllerType: NewsWidgetController,
  shouldTriggerOnRenderComplete: true,
  createModule: true,
  observe: true
};

export default Compose(settings);
